'use client';

import CustomImageWithFallback from '@/components/custom-image-with-fallback';
import { APP_ASSETS } from '@/constant/assets';
import { cn } from '@/lib/utils';
import '@/styles/globals.css';
import { Inter } from 'next/font/google';

const inter = Inter({ subsets: ['latin'] });

export default function RootLayout() {
    const onGoBack = () => {
        window.history.back();
    };

    return (
        <html suppressHydrationWarning lang='en'>
            <body className={cn(inter.className, 'm-0 overflow-y-hidden p-0')}>
                <main className='relative bg-gradient-to-br from-white via-white to-primary/10'>
                    <div className='mx-auto flex h-screen max-w-screen-xl items-center justify-start px-4 md:px-8'>
                        <div className='mx-auto max-w-lg flex-1 flex-row items-center justify-start gap-24 md:flex md:max-w-none'>
                            <div className='max-w-lg max-md:hidden'>
                                <CustomImageWithFallback
                                    src={APP_ASSETS['LOGO_COLOR_NO_TEXT']}
                                    width={120}
                                    height={120}
                                    alt='LOGO'
                                    className='h-36 w-auto object-cover'
                                />
                            </div>
                            <div className='mt-4 max-w-lg flex-1 space-y-3 md:mt-0'>
                                <h3 className='font-semibold text-indigo-600'>
                                    404 Error
                                </h3>
                                <p className='text-4xl font-semibold text-gray-800 sm:text-5xl'>
                                    Page not found
                                </p>
                                <p className='text-gray-600'>
                                    Sorry, the page you are looking for could
                                    not be found or has been removed.
                                </p>
                                <button
                                    type='button'
                                    onClick={onGoBack}
                                    className='inline-flex items-center gap-x-1 font-medium text-indigo-600 duration-150 hover:text-indigo-400'
                                >
                                    Go back
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        viewBox='0 0 20 20'
                                        fill='currentColor'
                                        className='h-5 w-5'
                                    >
                                        <path
                                            fillRule='evenodd'
                                            d='M5 10a.75.75 0 01.75-.75h6.638L10.23 7.29a.75.75 0 111.04-1.08l3.5 3.25a.75.75 0 010 1.08l-3.5 3.25a.75.75 0 11-1.04-1.08l2.158-1.96H5.75A.75.75 0 015 10z'
                                            clipRule='evenodd'
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <footer className='absolute bottom-0 right-0 p-1 text-xs text-gray-600'>
                        <h6>
                            Powered by{' '}
                            <a
                                title='Pyramid Software & Consulting'
                                href='/'
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                PSC
                                <span className='sr-only'>
                                    -Pyramid Software & Consulting
                                </span>
                            </a>
                            . © 2018 PSC All rights reserved
                        </h6>
                    </footer>
                </main>
            </body>
        </html>
    );
}
